export const COMPLETED_PROGRESS = 100;
export const INTERVAL_TIME = 100;
export const DELAY_BEFORE_CALLBACK = 500;
